
    // This file is generated by scripts/generateEnumExports.mjs
    // Do not edit this file manually

    export const InvoicingRequestStatusEnum = {
  PENDING: 'PENDING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  UNKNOWN: 'UNKNOWN'
};

export const RoleEnum = {
  USER: 'USER',
  ADMIN: 'ADMIN'
};

export const JobTypeEnum = {
  Project: 'Project',
  TimeMaterial: 'TimeMaterial'
};

export const JobStateEnum = {
  Idea: 'Idea',
  Planning: 'Planning',
  Running: 'Running',
  Paused: 'Paused',
  Completed: 'Completed',
  Aborted: 'Aborted'
};

export const OrderTypeEnum = {
  Labor: 'Labor',
  Material: 'Material'
};

export const OrderStateEnum = {
  Running: 'Running',
  Renewed: 'Renewed',
  Replaced: 'Replaced',
  Completed: 'Completed',
  Aborted: 'Aborted'
};

export const SkillTypeEnum = {
  Frontend: 'Frontend',
  Backend: 'Backend',
  Designer: 'Designer',
  Administrator: 'Administrator',
  Other: 'Other'
};

export const ActivityStateEnum = {
  Resume: 'Resume',
  Invoiced: 'Invoiced',
  Paid: 'Paid',
  Aborted: 'Aborted'
};

export const MarkTypeEnum = {
  WorkedHours: 'WorkedHours',
  Vacation: 'Vacation',
  Illness: 'Illness',
  Licence: 'Licence',
  ROL: 'ROL',
  ExFestivities: 'ExFestivities',
  Loss: 'Loss',
  Other: 'Other'
};

export const ValueCategoryEnum = {
  Employee: 'Employee',
  Rent: 'Rent',
  Cost: 'Cost',
  Sale: 'Sale',
  Other: 'Other'
};

    export type InvoicingRequestStatus = keyof typeof InvoicingRequestStatusEnum;
export type Role = keyof typeof RoleEnum;
export type JobType = keyof typeof JobTypeEnum;
export type JobState = keyof typeof JobStateEnum;
export type OrderType = keyof typeof OrderTypeEnum;
export type OrderState = keyof typeof OrderStateEnum;
export type SkillType = keyof typeof SkillTypeEnum;
export type ActivityState = keyof typeof ActivityStateEnum;
export type MarkType = keyof typeof MarkTypeEnum;
export type ValueCategory = keyof typeof ValueCategoryEnum;
  